import type { FunctionComponent } from "react";
import { useParams } from "react-router-dom";
import CampaignPostSearchBrandPartial from "../../../partials/brand/home/campaign-posts/campaign-post-search.brand.partials";

export const CampaignPostSearchBrandScreen: FunctionComponent = () => {
	const { campaignId } = useParams();

	if (!campaignId) {
		throw new Error("campaign id not found");
	}

	return <CampaignPostSearchBrandPartial />;
};
